import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import { SchemaComponentForm } from "../../../FollowUps/followup-form/modules/DynamicSection/components/SchemaComponentForm";
import { amountTypographySx } from "../styles";

const NewAppointment = ({
  newAppointment,
  setNewAppointments,
  flatSchema,
  servicesAmount,
  providerTypeOptions,
  onRemove,
}) => {
  const handleChange = (updatedData) => {
    setNewAppointments((forms) =>
      forms.map((f) =>
        f.id === newAppointment.id
          ? {
              ...updatedData,
              administered_services: [...f.administered_services],
            }
          : f
      )
    );
  };

  return (
    <Box className="flex flex-row items-center gap-4" sx={{ mb: 2 }}>
      <SchemaComponentForm
        schema={flatSchema}
        handleChange={handleChange}
        data={newAppointment}
        commitOnBlurOnly
        onCommit={(finalForm) => handleChange(finalForm)}
        staticOptionsByField={{ provider_type: providerTypeOptions }}
        additionalReq={{
          provider_type: {
            isRequired: true,
          },
        }}
      />
      <Typography sx={amountTypographySx}>${servicesAmount || 0.0}</Typography>
      <IconButton
        data-skip-blur-commit="true"
        sx={{ color: HNSColors.failure[500], mt: 4, ml: 2 }}
        onClick={onRemove}
      >
        <Close sx={{ fontSize: 36 }} />
      </IconButton>
    </Box>
  );
};

export default NewAppointment;
